import React from "react";
import PropTypes from "prop-types";
const AlertComponent = ({ message, onClose, classVal }) => {

  return (
    message!="" && (
      <div
        style={{
          position: "fixed",
          top: "12%",
          right: "2%",
          width: "30%",
          zIndex: 9999,
        }}
      >
        <div
          className={`alert alert-dismissible fade show ${
            classVal ? "alert-success" : "alert-danger" 
          }`}
          role="alert"
        >
          {message}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>
      </div>
    )
  );
};
AlertComponent.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
export { AlertComponent };
